import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
import CargomaticTooltip from '../Tooltip';
import ErrorLabel from './ErrorLabel';

const Checkbox = ({
  id,
  label,
  children,
  checked,
  info,
  helptext,
  onChange,
  disabled,
  className,
  inputClassNames,
  error,
  style,
  hideLabel,
  name,
  dataTestId,
}) => {
  function handleChange(e) {
    onChange(e.target.checked);
  }

  let body;

  if (label) {
    body = label;
  } else if (children) {
    body = children;
  }

  function renderErrorMessage() {
    if (!(error && error.message)) {
      return null;
    }
    return (
      <ErrorLabel dataTestId="ErrorLabel-ca603a1c" className="mt-1 mb-4">
        {error.message}
      </ErrorLabel>
    );
  }

  const hasLabel = !hideLabel && body;
  const containerClassName = getClassName('relative', className);

  // Wrapping the input inside the <label> makes clicking the text toggle the
  // control natively — no htmlFor/id association (which breaks when ids collide
  // across the page).
  const labelWrapperClassName = getClassName('relative flex items-center', {
    'cursor-pointer': !disabled,
    'cursor-not-allowed': disabled,
  });

  const labelTextClassName = getClassName({
    'ml-2': hasLabel,
    'text-sm': hasLabel,
  });

  return (
    <div data-testid={dataTestId} className={containerClassName} style={style}>
      <label className={labelWrapperClassName}>
        <span data-testid="div-8b0affe4" className="flex items-center h-5">
          <input
            data-testid={`checkBox-${name}`}
            type="checkbox"
            id={id}
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
            className={`w-4 h-4 border-gray-200 border-solid rounded text-green focus:ring-green ${inputClassNames}`}
          />
        </span>
        {hasLabel && (
          <span data-testid="div-7f760401" className={labelTextClassName}>
            <span className="flex items-center font-medium text-gray-700">
              {body}
              {info && (
                <CargomaticTooltip id={info} className="ml-1">
                  {info}
                </CargomaticTooltip>
              )}
            </span>
          </span>
        )}
      </label>
      {helptext && <div className="mt-1 ml-6 text-sm">{helptext}</div>}
      {renderErrorMessage()}
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.any,
  info: PropTypes.string,
  helptext: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  name: PropTypes.string,
  dataTestId: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  inputClassNames: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  style: PropTypes.object,
  error: PropTypes.object,
};

Checkbox.defaultProps = {
  hideLabel: false,
  checked: false,
  disabled: false,
  error: {},
};

export default Checkbox;
